import service from "./fetchInterceptor";

/**
 * Iniciar sesión
 */
export function login(email, password) {
  return service.post(
    `/auth/login`,
    { email, password },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
}

/**
 * Obtener usuario por token
 */
export function userByToken(id, token) {
  if (!id || !token || token === "undefined" || id === "undefined") {
    return Promise.reject({ message: "Token o ID inválido" });
  }
  return service.get(`/users/${id}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
  });
}

/**
 * Refrescar tokens
 */
export function refreshTokens(refreshToken) {
  return service.post(
    `/auth/refresh-tokens`,
    { refreshToken },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
}